/**
 * <SoundToggle>: M5.T8.
 *
 * Per IMPLEMENTATION_PLAN.md §7 M5.T8 ("Settings toggle in lobby +
 * in-game"). A small reactive switch bound to the `$sfxMuted` nanostore
 *: flipping it persists to localStorage.
 *
 * (T16 (4.2) removed the optional brush-rasp sub-toggle: the brush-rasp
 *  sound was never wired to playback, so the sub-toggle controlled a dead
 *  feature. Only the master Sound toggle remains.)
 */

import { useStore } from "@nanostores/preact";
import { $sfxMuted, playSfx } from "./sfx.js";
import { ScribbleToggle } from "../forms/ScribbleToggle.js";

export function SoundToggle() {
  const muted = useStore($sfxMuted);
  return (
    <div class="sound-toggle" data-testid="sound-toggle">
      <ScribbleToggle
        id="sfx-mute-toggle"
        label={muted ? "Sound: off" : "Sound: on"}
        checked={!muted}
        onChange={(on) => {
          $sfxMuted.set(!on);
          // If user just turned sound on, play a tiny confirmation chirp
          // so they hear something: this also resumes the suspended
          // AudioContext while we're inside a user gesture.
          if (on) playSfx("correct");
        }}
      />
    </div>
  );
}
